<template>
  <div class="flex justify-center">
    <div class="sk-header absolute top-0 left-0 flex justify-end items-center">
      <div class="w-64">
        <div class="justify-between flex">
          <div class="flex flex-col justify-center items-end pr-2">
            <span class="sk-line h-4 mb-2 w-40"/>
            <span class="sk-line h-4 w-2/3"/>
          </div>
          <span class="sk-header-avatar relative rounded-full overflow-hidden" />
        </div>
      </div>
    </div>
    <div class="absolute w-24 left-0 top-0 bg-zt-dark-200 h-full" />
    <div class="w-2/3 max-w-screen-lg mt-20">
      <div class="flex">
        <div class="w-2/3 mr-3 height-box-main bg-zt-white flex">
          <div class="w-1/2 py-16 px-4">
            <span class="sk-line-alter block h-4 w-40" />
            <span class="sk-line-alter block h-3 w-full mt-2" />
            <div class="mt-32">
              <div class="flex">
                <span class="sk-line-alter h-8 w-1/2 block mr-3"></span>
                <span class="sk-line-alter h-8 w-1/2 block"></span>
              </div>
              <div class="flex mt-3">
                <span class="sk-line-alter h-8 w-1/2 block mr-3"></span>
                <span class="sk-line-alter h-8 w-1/2 block"></span>
              </div>
            </div>
          </div>
          <div class="w-1/2 py-16 px-4">
            <span class="sk-line-alter block h-full w-full"/>
          </div>
        </div>
        <div class="w-1/3 height-box-main bg-zt-white flex flex-col items-center py-16 px-4">
          <div class="sk-line-alter h-20 w-20" />
          <div class="sk-line-alter h-6 w-32 mt-12" />
          <div class="sk-line-alter h-8 w-24 mt-12" />
        </div>
      </div>
      <div class="flex mt-4">
        <div class="w-1/3 mr-3">
          <div class="p-4 flex bg-zt-white">
            <span class="sk-line-alter block h-8 w-1/2 block mr-3" />
            <span class="sk-line-alter block h-8 w-1/2 block " />
          </div>
          <div class="p-4 bg-zt-white h-64 mt-3">
            <span class="sk-line-alter block h-full w-full" />
          </div>
          <div class="flex mt-3">
            <div class="p-4 w-1/2 bg-zt-white mr-2">
              <span class="sk-line-alter block w-full h-8" />
            </div>
            <div class="p-4 w-1/2 bg-zt-white">
              <span class="sk-line-alter block w-full h-8" />
            </div>
          </div>
        </div>
        <div class="w-1/3 mr-3">
          <div class="flex flex-col bg-zt-white p-3">
            <span class="sk-line-alter block w-1/2 h-5" />
            <div class="flex flex-wrap">
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3 mt-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3 mt-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3 mt-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3 mt-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3 mt-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3 mt-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3 mt-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3 mt-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3 mt-3" />
            </div>
          </div>
          <div class="mt-3 flex flex-col bg-zt-white px-3 py-4">
            <span class="sk-line-alter block w-2/3 h-5" />
            <div class="flex flex-wrap mt-8 pb-16">
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3 mt-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3 mt-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3 mt-3" />
            </div>
          </div>
        </div>
        <div class="w-1/3">
          <div class="flex flex-col bg-zt-white px-4 py-8">
            <span class="sk-line-alter block w-2/3 h-5" />
            <span class="sk-line-alter block w-1/3 h-5 mt-8" />
            <div class="flex items-center mt-8">
              <span class="sk-line-alter block w-1/3 h-5 mr-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3" />
            </div>
            <div class="flex items-center mt-8">
              <span class="sk-line-alter block w-1/3 h-5 mr-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3" />
              <span class="sk-tiny-avatar relative rounded-full overflow-hidden mr-3 hidden xl:block" />
              <span class="sk-tiny-avatar relative rounded-full overflow-hidden mr-3 hidden xl:block" />
            </div>
            <div class="flex items-center mt-8">
              <span class="sk-line-alter block w-1/3 h-5 mr-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3" />
              <span class="sk-tiny-avatar relative rounded-full overflow-hidden mr-3 hidden xl:block" />
              <span class="sk-tiny-avatar relative rounded-full overflow-hidden mr-3 hidden xl:block" />
            </div>
            <div class="flex items-center mt-8">
              <span class="sk-line-alter block w-1/3 h-5 mr-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3" />
              <span class="sk-tiny-avatar block relative rounded-full overflow-hidden mr-3" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bgSkeletonSSO"
}
</script>

<style lang="scss" scoped>
.sk-header {
  width: 100%;
  height: 4.469rem;
  margin: 0 0.006rem 0 0;
  padding: 0 3.722rem 0 0;
  box-shadow: 0 4px 4px 0 rgba(150, 150, 150, 0.1);
  background-color: #ffffff;
}
.sk-header-avatar {
  background-color: #c4c4c4;
  width: 50px;
  height: 50px;
}
.sk-header-avatar::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.sk-tiny-avatar {
  background-color: #c4c4c4;
  width: 32px;
  height: 32px;
}
.sk-tiny-avatar::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.sk-info-avatar {
  background-color: #c4c4c4;
  width: 80px;
  height: 80px;
}
.sk-info-avatar::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.sk-bh-avatar::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.sk-line {
  background-color: #c4c4c4;
  overflow: hidden;
  position: relative;
  border-radius: 10px;
}
.sk-line::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.sk-line-alter {
  background-color: #dedede;
  overflow: hidden;
  position: relative;
}
.sk-line-alter::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.height-box-main {
  height: 24.18rem;
}
@keyframes load {
  from {
    left: -150px;
  }
  to {
    left: 100%;
  }
}
</style>
